import React, { useRef, useEffect } from "react";
import { useLocation, Outlet } from "react-router-dom";
import { Box, useMediaQuery, useTheme } from "@mui/material";
import Header from "./Header";
import Footer from "./Footer";
import WhatsAppButton from "../common/WhatsAppButton";
import ScrollToTop from "../common/ScrollToTop";

const CHECKOUT_ROUTES = [
  "/donate-product-page",
  "/donate-once-page",
  "/donate-monthly-page",
  "/overseas-donor-page",
];

const isCampaignPath = (path) =>
  path.startsWith("/campaign/") || path.startsWith("/story/");

const Layout = () => {
  const location = useLocation();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const prevPathRef = useRef(null);

  useEffect(() => {
    const prev = prevPathRef.current;
    const curr = location.pathname;
    if (prev && isCampaignPath(prev) && !CHECKOUT_ROUTES.includes(curr)) {
      sessionStorage.setItem("selectedProductsCount", "0");
      sessionStorage.setItem("selectedProducts", "[]");
      window.dispatchEvent(new CustomEvent('selectedProductsUpdated'));
    }
    prevPathRef.current = curr;
  }, [location.pathname]);
  
  const noHeaderFooterRoutes = ["/login", "/register", "/forgot-password", "/verification", "/reset-password"];
  const noFooterRoutes = ["/profile"]; // legacy exact path check (kept for clarity)
  const noWhatsAppRoutes = [
    "/donate-once-page",
    "/donate-monthly-page",
    "/donate-product-page",
    "/overseas-donor-page",
    "/thankyou-Page",
    "/Monthly/thankyou-Page",
    "/faq-page",
  ];
  
  // For mobile profile pages, we only want to hide the header on the main profile page,
  // but show it on subpages like "My Profile"
  const isMainProfilePage = location.pathname === "/profile";
  const isProfileSubPage = location.pathname.startsWith("/profile/");
  
  // Hide header if:
  // 1. Route is in noHeaderFooterRoutes, or
  // 2. On mobile AND it's specifically the main profile page
  const hideHeader = noHeaderFooterRoutes.includes(location.pathname) || 
                    (isMobile && isMainProfilePage);
  
  const isProfileRoute = location.pathname === "/profile" || location.pathname.startsWith("/profile/");
  const profileFooterAllowedRoutes = [
    "/profile/download-80g-form",
    "/profile/download-10b-form",
    "/profile/80g-form",
    "/profile/10b-form",
  ];
  const hideFooter = (isProfileRoute && !profileFooterAllowedRoutes.includes(location.pathname)) 
                     || noFooterRoutes.includes(location.pathname) 
                     || hideHeader;
  const hideWhatsApp = hideHeader || noWhatsAppRoutes.includes(location.pathname);
  
  return (
    <Box sx={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
      <ScrollToTop />
      {!hideHeader && <Header />}
      <Box component="main" sx={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
        <Outlet />
      </Box>
      {!hideHeader && !hideFooter && <Footer />}
      {!hideHeader && !hideWhatsApp && <WhatsAppButton />}
    </Box>
  );
};

export default Layout;
